import styled from 'styled-components';

const ServicesSection = styled.section`
  background-color: #e1f5fe;
  padding: 6rem 1.5rem;
  @media (min-width: 640px) {
    padding: 8rem 1.5rem;
  }
`;

const Container = styled.div`
  max-width: 80rem;
  margin: 0 auto;
  padding: 0 1.5rem;
  @media (min-width: 1024px) {
    padding: 0 2rem;
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const Title = styled.h1`
  font-size: 2.25rem;
  font-weight: 600;
  line-height: 1.2;
  color: #111827;
  @media (min-width: 640px) {
    font-size: 3rem;
  }
`;

const Subtitle = styled.h2`
  // font-size: 1.125rem;
  // line-height: 1.75rem;
  // font-weight: 500;
  // color: #4f46e5;
  // margin-top: 0.5rem;

    font-size: 60px;
    font-weight: 500;
    line-height: 1.2;
    letter-spacing: -0.32px;
    display: block;
    font-weight: bold;
`;

const Grid = styled.div`
  max-width: 48rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  @media (min-width: 640px) {
    gap: 2.5rem;
  }
  @media (min-width: 1024px) {
    max-width: none;
    grid-template-columns: 3fr 2fr; /* 60% content, 40% image */
    margin: 0;
    align-items: start;
  }
`;

const ContentWrapper = styled.div`
  padding-top: 1rem;
  @media (min-width: 1024px) {
    padding-right: 2rem;
  }
`;

const Content = styled.div`
  max-width: 28rem;
`;

const Description = styled.p`
  margin-top: 1.5rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  color: #4b5563;
`;

const List = styled.dl`
  margin-top: 2.5rem;
  max-width: 36rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  font-size: 0.875rem;
  line-height: 1.75rem;
  color: #6b7280;
`;

const ListItem = styled.div`
  position: relative;
  padding-left: 2.25rem;
`;

const ItemTitle = styled.dt`
  display: inline;
  font-weight: 600;
  color: #111827;
`;

const ItemDescription = styled.dd`
  display: block;
  padding-top: 3px;
`;

const Icon = styled.svg`
  position: absolute;
  top: 0.25rem;
  left: 0.25rem;
  width: 1.25rem;
  height: 1.25rem;
  color: #4f46e5;
`;

const Image = styled.img`
  width: 100%;
  max-width: none;
  border-radius: 0.75rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.1);
  @media (min-width: 768px) {
    width: 100%;
    margin-left: 0;
  }
  @media (min-width: 1024px) {
    margin-left: 0;
    height: 100%;
    object-fit: cover;
  }
`;

const Services = () => {
  return (
    <ServicesSection>
      <Container>
        <Header>
          <Subtitle>Streamlined Solutions for Your Success</Subtitle>
        </Header>
        <Grid>
          <ContentWrapper>
            <Content>
              <Description>
                Discover our comprehensive suite of services designed to enhance efficiency and drive success.
              </Description>
              <List>
                <ListItem>
                  <ItemTitle>
                    <Icon viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path d="M5.5 17a4.5 4.5 0 0 1-1.44-8.765 4.5 4.5 0 0 1 8.302-3.046 3.5 3.5 0 0 1 4.504 4.272A4 4 0 0 1 15 17H5.5Zm3.75-2.75a.75.75 0 0 0 1.5 0V9.66l1.95 2.1a.75.75 0 1 0 1.1-1.02l-3.25-3.5a.75.75 0 0 0-1.1 0l-3.25 3.5a.75.75 0 1 0 1.1 1.02l1.95-2.1v4.59Z" clipRule="evenodd" fillRule="evenodd" />
                    </Icon>
                    Client Management.
                  </ItemTitle>
                  <ItemDescription>
                    Comprehensive portfolio management with advanced client analytics and tracking capabilities.
                  </ItemDescription>
                </ListItem>
                <ListItem>
                  <ItemTitle>
                    <Icon viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path d="M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z" clipRule="evenodd" fillRule="evenodd" />
                    </Icon>
                    Policy Administration.
                  </ItemTitle>
                  <ItemDescription>
                    Efficient policy management, from issuance to renewals, with automated workflows and compliance checks.
                  </ItemDescription>
                </ListItem>
                <ListItem>
                  <ItemTitle>
                    <Icon viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path d="M4.632 3.533A2 2 0 0 1 6.577 2h6.846a2 2 0 0 1 1.945 1.533l1.976 8.234A3.489 3.489 0 0 0 16 11.5H4c-.476 0-.93.095-1.344.267l1.976-8.234Z" />
                      <path d="M4 13a2 2 0 1 0 0 4h12a2 2 0 1 0 0-4H4Zm11.24 2a.75.75 0 0 1 .75-.75H16a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75V15Zm-2.25-.75a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75H13a.75.75 0 0 0 .75-.75V15a.75.75 0 0 0-.75-.75h-.01Z" clipRule="evenodd" fillRule="evenodd" />
                    </Icon>
                    Digital Distribution.
                  </ItemTitle>
                  <ItemDescription>
                    Expand your reach with our digital distribution tools, enabling seamless policy delivery and online access.
                  </ItemDescription>
                </ListItem>
              </List>
            </Content>
          </ContentWrapper>
          <Image
            src="https://images.unsplash.com/photo-1516368694098-47836cebec97?q=80&w=1301&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Product screenshot"
            width="400"
            height="400"
          />
        </Grid>
      </Container>
    </ServicesSection>
  );
};

export default Services;